<template>
<div style="background-color: white;">
  <div style="width:300px">
    <v-btn class="hide-on-print" max-width="300px" color="primary" block @click="print()">печать</v-btn>
  </div>
<html id="printableArea">
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
    <link rel="stylesheet" href="print-report.css">
  </head>
  <body>
  <div class="printableArea">
    <span v-html="this.report"></span>

  </div>
  </body>
</html>
</div>
</template>

<script>

// import moment from 'moment'
import pako from 'pako'
import { Base64 } from 'js-base64'

export default {
  name: 'PrintStatement',
  props: [ 'data' ],
  data: () => ({
    report: null,
  }),
  methods: {
    print () {
      const printContents = document.getElementById('printableArea').innerHTML
      // const originalContents = document.body.innerHTML
      document.body.innerHTML = printContents
      setTimeout(() => { window.print() }, 1000)
    }
  },
  computed: {
  },
  mounted () {
    // const base64Data = this.$route.query.data
    const binaryArchived = Base64.decode(this.$route.query.data).split(',').map(x => parseInt(x))
    const inflated = new TextDecoder('utf-8').decode(pako.inflate(binaryArchived))
    this.report = JSON.parse(inflated)
  },
  watch: {
  }
}
</script>
